import { render } from "./DeckAndSeat.vue?vue&type=template&id=54d7294b&scoped=true"
import script from "./DeckAndSeat.vue?vue&type=script&lang=js"
export * from "./DeckAndSeat.vue?vue&type=script&lang=js"

import "./DeckAndSeat.vue?vue&type=style&index=0&id=54d7294b&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d7294b"]])

export default __exports__